import angular from 'angular';
import navbar from './navbar/navbar';
import license from './license/license';
import logo from './logo/logo';
import footer from './ybfooter/ybfooter';
import smallfooter from './yb-small-footer/ybfooter';
import modal from './modal/modal';
import navtab from './navtab/navtab';
import pager from './pager/pager';
import progressbar from './progressbar/progressbar';
import form from './form/form';
import buttonTab from './button-tab/button-tab';
import ybInput from './yb-input/yb-input';
import ybSelect from './yb-select/yb-select';
import radioList from './radio-list/radio-list';
import dialogModal from './dialog-modal/dialog-modal';
import language from './language/language';
import autoFocus from './common.directive/auto-focus.directive';
import './common.scss';
let commonModule = angular.module('app.common', [
    navbar,
    license,
    logo,
    footer,
    smallfooter,
    modal,
    navtab,
    pager,
    progressbar,
    form,
    buttonTab,
    ybInput,
    ybSelect,
    radioList,
    dialogModal,
    language
])
    .directive('autoFocus', autoFocus)

    .name;

export default commonModule;



// WEBPACK FOOTER //
// ./src/app/common/common.js